<template>
     <el-card  v-loading="loading && trips.length">
        <h5>Passenger Traffic by Route and Time – Today</h5>
        <bar-chart :labels="viewsChart.labels" :height="350" :datasets="viewsChart.datasets" v-if="visible">
        </bar-chart>
    </el-card>
</template>
<script>

import { Analytic } from '@/resources/analytics'
import BarChart from 'src/components/UIComponents/Charts/BarChart'

const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
};

export default {
    props: ['update'],
    components: {
        BarChart
    },
    data() {
        return {
            visible: false,
            trips: [],
            loading: false,
            viewsChart: {
                labels: [],
                datasets: [
                    {
                        label: "Tickets",
                        borderColor: '#51bcda',
                        backgroundColor: '#51bcda',
                        hoverBorderColor: '#51bcda',
                        borderWidth: 5,
                        data: [],
                    }
                ]
            },
        }
    },
    watch: {
        update: function(){
            this.getData()
        }
    },
    created: function () {
        this.getData()
    },
    methods: {
        dateLabel(date){
            return this.$moment(date).format('MMM DD, YYYY')
        },
        getData() {
            let params = this.form
            this.loading = true
            this.visible = false
            Analytic.passengersTravellingByRoute(params)
                .then(result => {
                    this.trips = result.data.trips
                    this.collectData(result.data.trips)
                })
                .catch(() => {

                }).finally(() => {
                    this.loading = false
                })
        },
        collectData(trips) {
            this.viewsChart.labels = []
            let counts = []
            let labels = []
            trips.forEach(trip => {
                labels.push(trip.route_code+' - ' + trip.time)
                counts.push(trip.total)
            });
            this.viewsChart.datasets[0].data = counts
            this.viewsChart.labels = labels
            this.visible = true
        }
    }
}
</script>
<style lang="scss"></style>